import { render, staticRenderFns } from "./part-two-info.vue?vue&type=template&id=48217fba&scoped=true"
import script from "./part-two-info.vue?vue&type=script&lang=js"
export * from "./part-two-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48217fba",
  null
  
)

export default component.exports